export enum Modals {
  ApiTokenDestroyModal = 'apiTokenDestroyModal',
  ApiTokenFormModal = 'apiTokenFormModal',
  DashboardMonitoringFilterModal = 'dashboardMonitoringFilterModal',
  DashboardOverviewFilterModal = 'dashboardOverviewFilterModal',
  DashboardTimelineFilterModal = 'dashboardTimelineFilterModal',
  DataImportDestroyModal = 'dataImportDestroyModal',
  DataImportErrorsModal = 'dataImportErrorsModal',
  CompanyDomainDestroyModal = 'companyDomainDestroyModal',
  CompanyDomainFormModal = 'companyDomainFormModal',
  CompanyDomainVerifyModal = 'companyDomainVerifyModal',
  CompanyPlanFailedModal = 'companyPlanFailedModal',
  CompanyPlanParkedModal = 'companyPlanParkedModal',
  CompanyPlanSkippedModal = 'companyPlanSkippedModal',
  CompanyPlanUsageModal = 'companyPlanUsageModal',
  DepartmentDestroyModal = 'departmentDestroyModal',
  DestroyModal = 'destroyModal',
  DocumentListFilter = 'documentListFilter',
  FilterModal = 'filterModal',
  GenerateReportModal = 'generateReportModal',
  HomeApplyTemplateModal = 'homeApplyTemplateModal',
  HomeCustomizeTabsModal = 'homeCustomizeTabsModal',
  HomePublishModal = 'homePublishModal',
  HomeWidgetModal = 'homeWidgetModal',
  HowToUseApi = 'howToUseApi',
  LegendFormModal = 'legendFormModal',
  MoveMembersToTeamModal = 'moveMembersToTeamModal',
  SiteCodeOfConductDestroyModal = 'siteCodeOfConductDestroyModal',
  SiteDestroyModal = 'siteDestroyModal',
  SiteListFilter = 'siteListFilter',
  SsoIntegrationDestroyModal = 'ssoIntegrationDestroyModal',
  TeamDestroyModal = 'teamDestroyModal',
  TeamMemberRemoveModal = 'teamMemberRemoveModal',
  UserDeleteModal = 'userDeleteModal',
  UserFormModal = 'userFormModal',
}
